<template>
  <div v-if="getShowAlert" class="addtocart">
    <modal ref="alertModal" @close="acknowledge" full-header :hide-footer="true">
      <template slot="body">
        <div class="container">
          <div class="row">
            <div class="header col-md-12">
              {{ getAlertPayload.title }}
            </div>
            <br />
            <div
              class="modalBody ios-scroll col-md-12"
              v-html="getAlertPayload.body"
            ></div>
            <div class="modalFooter">
              <button
                @click="acknowledge()"
                class="btn btn-primary"
                :style="buttonStyles"
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import modal from "./modal.vue";

export default {
  name: "AlertModal",
  components: { modal },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "getShowAlert",
      "getAlertPayload",
      "buttonStyles",
    ]),
  },
  methods: {
    ...mapMutations(["setShowAlert"]),
    acknowledge() {
      this.$refs.alertModal.hideModal();
      this.setShowAlert(false);
    },
  },
};
</script>
<style scoped>
.header {
  font-size: 18px;
  /* color: #585858; */
  color: navy;
  padding: 19px;
}
.modalBody {
  color: #323639;
  font-size: 15px;
  padding: 0px 19px;
  max-height: 300px;
  overflow-y: scroll;
}
.modalFooter {
  padding: 0px 19px;
  margin-top: 25px;
  width: 100%;
}
.modal-content {
  border-radius: 12px;
}
.modalFooter button {
  width: 100%;
  background: #55a7ff;
  border-radius: 7px;
}
</style>
